import ModalDeleteFilled from '../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps } from '../../../../../../baseComponents/ModalsLayouts/types'
import { useFetchText } from '../../../../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'


interface ModalDeleteLangProps extends ModalEditComponentProps { }

const ModalDeleteLang: React.FC<ModalDeleteLangProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/config/lang/updateLang',
        data: {
            id: allRowData?.id,
            active: !allRowData?.active
        }
    })
    let translations = {
        title: t('sureUnableLang', '¿Seguro quieres desactivar este idioma?'),
        subtitle: t('onceDeletedCouldBeRecovered', 'Una vez desactivado se podrá reactivar de nuevo'),
        buttonAccept: t('unable', 'Desactivar')
    }
    if (!allRowData?.active) {
        translations = {
            title: t('sureEnableLang', '¿Seguro quieres activar este idioma?'),
            subtitle: t('onceEnabledCouldBeDeleted', 'Una vez activado se podrá desactivar de nuevo'),
            buttonAccept: t('enable', 'Activar')
        }
    }
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={translations} />
    )
}

export default ModalDeleteLang